import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, Star } from "lucide-react";
import { COMPANY } from "../../lib/api";
import { SERVICES, SUBURBS } from "../../data/site";

export function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#1A2421] text-white/80 relative">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-16 grid gap-12 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <img src="/logo-full-white.png" alt="West Face Roofing & Projects" className="h-14 w-auto mb-5" />
          <p className="text-sm leading-relaxed mb-4">{COMPANY.tagline}. {COMPANY.subtagline} Building roofs since {COMPANY.since}.</p>
          <p className="text-[#62B848] text-sm font-semibold">Licensed &amp; insured · Perth, WA</p>
        </div>

        <div>
          <h4 className="font-display font-bold text-white mb-4">Services</h4>
          <ul className="space-y-2 text-sm">
            {SERVICES.slice(0, 6).map((s) => (
              <li key={s.slug}><Link to={`/services/${s.slug}`} className="hover:text-[#62B848] transition-colors">{s.name}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-display font-bold text-white mb-4">Company</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-[#62B848] transition-colors">About us</Link></li>
            <li><Link to="/our-work" className="hover:text-[#62B848] transition-colors">Our work</Link></li>
            <li><Link to="/property-strata-managers" className="hover:text-[#62B848] transition-colors">Property &amp; Strata Managers</Link></li>
            <li><Link to="/service-areas" className="hover:text-[#62B848] transition-colors">Service areas</Link></li>
            <li><Link to="/contact" className="hover:text-[#62B848] transition-colors">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display font-bold text-white mb-4">Get in touch</h4>
          <ul className="space-y-3 text-sm">
            <li><a href={COMPANY.phoneHref} className="flex items-center gap-2.5 hover:text-[#62B848]"><Phone size={16} className="text-[#62B848]" /> {COMPANY.phone}</a></li>
            <li><a href={`mailto:${COMPANY.email}`} className="flex items-center gap-2.5 hover:text-[#62B848]"><Mail size={16} className="text-[#62B848]" /> {COMPANY.email}</a></li>
            <li className="flex items-center gap-2.5"><MapPin size={16} className="text-[#62B848]" /> {COMPANY.address}</li>
            <li className="flex items-center gap-2.5"><Clock size={16} className="text-[#62B848]" /> {COMPANY.hours}</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/50">
          <p>© {new Date().getFullYear()} West Face Roofing. Licensed &amp; insured. Perth, WA.</p>
          <Link to="/command" data-testid="owner-login-link" className="hover:text-white/80 transition-colors">Owner login</Link>
        </div>
      </div>
    </footer>
  );
}
